<template>
  <footer>
    <section class="svg-background"></section>
    <LinkThree />
    <RedSocials />
    <section class="footer-container">
      <section class="container">
        <div class="columns">
          <div class="column is-6 has-text-right">
            <a href="https://www.osfatun.com.ar/">
              <img
                class="logo-footer"
                src="./../../assets/complete-logo-footer.svg"
                alt="logo"
              />
            </a>
          </div>
          <div class="column is-6 has-text-left">
            <a target="_blank" href="https://www.fatun.org.ar/">
              <img
                class="logo-federacion"
                src="./../../assets/federacion-logo-footer.svg"
                alt="logo"
              />
            </a>
          </div>
        </div>
        <div class="columns zaro is-multiline is-mobile">
          <div class="column is-12-mobile is-6-desktop has-text-left">
            <a target="_blank" href="https://www.argentina.gob.ar/sssalud">
              <img
                src="./../../assets/logo-sssaludconinfo.svg"
                width="60%"
                alt="zaro"
              />
            </a>
          </div>
          <div class="column is-12-mobile is-6-desktop has-text-right">
            <a target="_blank" href="https://zaro.com.ar">
              <img
                class="zaro"
                src="./../../assets/zaro.svg"
                width="85"
                alt="zaro"
              />
            </a>
          </div>
        </div>
      </section>
    </section>
  </footer>
</template>

<script>
import LinkThree from "./LinkThree";
import RedSocials from "./RedSocials";
export default {
  name: "Footer",
  components: {
    LinkThree,
    RedSocials,
  },
};
</script>

<style scoped>
.footer-container {
  margin-top: 50px;
  padding: 20px 0;
}
.svg-background {
  width: 100%;
  background: url("./../../assets/title-background.svg") center center no-repeat;
  background-size: 100%;
  height: 253px;
}
.zaro {
  margin-top: 10px;
}

@media screen and (max-width: 480px) {
  .footer-container {
    margin-top: 0;
    overflow: hidden;
  }
  .zaro {
    margin-top: 10px;
  }
  .logo-federacion {
    display: block;
    margin: 0 auto;
    max-width: 100%;
  }
  .svg-background {
    display: none;
  }
  .has-text-left,
  .has-text-right {
    text-align: center !important;
  }
}
</style>
